import { render } from "./NewCardList.vue?vue&type=template&id=e4572764&scoped=true"
import script from "./NewCardList.vue?vue&type=script&lang=js"
export * from "./NewCardList.vue?vue&type=script&lang=js"

import "./NewCardList.vue?vue&type=style&index=0&id=e4572764&lang=scss&scoped=true"
import "./NewCardList.vue?vue&type=style&index=1&id=e4572764&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4572764"]])

export default __exports__